import { render, staticRenderFns } from "./GoodsSearchModal.vue?vue&type=template&id=595b98e7"
import script from "./GoodsSearchModal.vue?vue&type=script&lang=js"
export * from "./GoodsSearchModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports